module.exports = __webpack_public_path__ + "images/the-critic-ed86157c4bd534dc6e82c76dc3786964.png";